import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'singleName'
})
export class SingleNamePipe implements PipeTransform {
    transform(fullName: string, order: 'first' | 'last'): any {
        const names = fullName ? fullName.split(' ') : ['n/a'];
        return order === 'first' ? names[0] : names[names.length - 1];
    }
}
